import { render, staticRenderFns } from "./DPI copy.vue?vue&type=template&id=5a8c69c0&scoped=true&"
import script from "./DPI copy.vue?vue&type=script&lang=js&"
export * from "./DPI copy.vue?vue&type=script&lang=js&"
import style0 from "./DPI copy.vue?vue&type=style&index=0&id=5a8c69c0&lang=scss&scoped=true&"
import style1 from "./DPI copy.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8c69c0",
  null
  
)

export default component.exports